module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100vh",
      "overflow-y": "scroll",
      "padding": "5px 10px",
      "background-color": "#F7F8FA"
    }
  }, _vm._l((_vm.expressList), function(express) {
    return _c('div', {
      staticClass: "content-block"
    }, [_c('div', {
      staticClass: "block-item"
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "center"
      }
    }, [(express.company === 1) ? _c('span', [_vm._v("顺丰快递")]) : _c('span', [_vm._v("跨越快递")]), _vm._v(" "), _c('span', [_vm._v("：" + _vm._s(express.mailNo) + " ")]), _vm._v(" "), _c('svg', {
      staticClass: "icon copySvg",
      attrs: {
        "t": "1691638351275",
        "data-clipboard-text": ((express.mailNo) + ": " + (express.contractNoList.join(',')) + " "),
        "id": "tag-copy",
        "viewBox": "0 0 1024 1024",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "p-id": "5506",
        "width": "16",
        "height": "16",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      },
      on: {
        "click": _vm.copy
      }
    }, [_c('path', {
      attrs: {
        "d": "M857.373005 65.290005 469.604424 65.290005c-34.211173 0-62.044078 27.832905-62.044078 62.043055l0 10.340509-63.076594 0c-25.993001 0-48.228421 16.346293-57.001225 39.293935L166.626995 176.967504c-34.21015 0-62.043055 27.832905-62.043055 62.043055l0 657.655358c0 34.21015 27.832905 62.043055 62.043055 62.043055l550.115086 0c34.21015 0 62.043055-27.832905 62.043055-62.043055l0-49.634444 78.587869 0c34.21015 0 62.043055-27.832905 62.043055-62.043055L919.41606 127.33306C919.41606 93.122911 891.583155 65.290005 857.373005 65.290005zM344.483752 179.035606l194.402595 0c10.833743 0 19.646456 8.813736 19.646456 19.646456 0 10.833743-8.813736 19.646456-19.646456 19.646456L344.483752 218.328517c-10.833743 0-19.646456-8.813736-19.646456-19.646456C324.836273 187.849342 333.650009 179.035606 344.483752 179.035606zM737.423099 896.665917c0 11.402701-9.278317 20.681018-20.681018 20.681018L166.626995 917.346935c-11.403724 0-20.681018-9.278317-20.681018-20.681018L145.945977 239.010559c0-11.402701 9.277294-20.681018 20.681018-20.681018l120.111588 0c8.197706 24.02723 30.977525 41.362037 57.744145 41.362037l194.402595 0c26.767644 0 49.54644-17.334807 57.744145-41.362037l120.111588 0c11.402701 0 20.681018 9.278317 20.681018 20.681018L737.422076 896.665917zM878.054023 784.988418c0 11.402701-9.278317 20.681018-20.681018 20.681018l-78.587869 0L778.785136 239.010559c0-34.21015-27.832905-62.043055-62.043055-62.043055L595.886549 176.967504c-8.771781-22.947641-31.007201-39.293935-57.001225-39.293935l-89.963964 0L448.921359 127.33306c0-11.403724 9.278317-20.681018 20.683065-20.681018l387.768581 0c11.402701 0 20.681018 9.277294 20.681018 20.681018L878.054023 784.988418z",
        "fill": "#5878fa",
        "p-id": "5507"
      }
    }), _c('path', {
      attrs: {
        "d": "M620.597347 334.252737 260.748652 334.252737c-11.422144 0-20.681018 9.259898-20.681018 20.681018s9.258874 20.681018 20.681018 20.681018l359.849718 0c11.42112 0 20.681018-9.259898 20.681018-20.681018S632.018467 334.252737 620.597347 334.252737z",
        "fill": "#5878fa",
        "p-id": "5508"
      }
    }), _c('path', {
      attrs: {
        "d": "M620.597347 454.201619 260.748652 454.201619c-11.422144 0-20.681018 9.259898-20.681018 20.681018 0 11.42112 9.258874 20.681018 20.681018 20.681018l359.849718 0c11.42112 0 20.681018-9.259898 20.681018-20.681018C641.278365 463.46254 632.018467 454.201619 620.597347 454.201619z",
        "fill": "#5878fa",
        "p-id": "5509"
      }
    }), _c('path', {
      attrs: {
        "d": "M440.673511 574.151525 260.748652 574.151525c-11.422144 0-20.681018 9.259898-20.681018 20.681018 0 11.42112 9.258874 20.681018 20.681018 20.681018l179.924859 0c11.42112 0 20.681018-9.259898 20.681018-20.681018C461.35453 583.411423 452.093609 574.151525 440.673511 574.151525z",
        "fill": "#5878fa",
        "p-id": "5510"
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "full-split-line"
    }), _vm._v(" "), _vm._l((express.contractNoList), function(contractNo) {
      return _c('div', {
        staticClass: "block-item"
      }, [_c('div', [_c('span', [_vm._v(" 实验编号：" + _vm._s(contractNo))])]), _vm._v(" "), _c('div', {
        staticClass: "update-address update-address-color",
        on: {
          "click": function($event) {
            return _vm.downloadExpressOutFile(contractNo)
          }
        }
      }, [_c('svg', {
        staticClass: "icon",
        attrs: {
          "t": "1691039522552",
          "viewBox": "0 0 1024 1024",
          "version": "1.1",
          "xmlns": "http://www.w3.org/2000/svg",
          "p-id": "5135",
          "width": "14",
          "height": "14",
          "xmlns:xlink": "http://www.w3.org/1999/xlink"
        }
      }, [_c('path', {
        attrs: {
          "d": "M511.689076 305.399622",
          "p-id": "5136",
          "fill": "#5878fa"
        }
      }), _vm._v(" "), _c('path', {
        attrs: {
          "d": "M512.005585 576.67584h-0.633018",
          "p-id": "5137",
          "fill": "#5878fa"
        }
      }), _vm._v(" "), _c('path', {
        attrs: {
          "d": "M97.745455 199.262953",
          "p-id": "5138",
          "fill": "#5878fa"
        }
      }), _vm._v(" "), _c('path', {
        attrs: {
          "d": "M646.209164 556.182807h-0.633019",
          "p-id": "5139",
          "fill": "#5878fa"
        }
      }), _vm._v(" "), _c('path', {
        attrs: {
          "d": "M657.901382 876.590545c10.882327 0 21.345745 8.823156 21.345745 19.705484s-10.46528 19.705484-21.347607 19.705484H221.938036c-25.918371 0-49.470371-10.591884-66.528349-27.649862-17.057978-17.057978-27.649862-40.609978-27.649862-66.528349V242.321222c0-25.918371 10.591884-49.470371 27.649862-66.528349 17.057978-17.057978 40.609978-27.649862 66.528349-27.649862h579.50208c25.914647 0 49.466647 10.593745 66.524626 27.651724 17.061702 17.061702 27.653585 40.613702 27.653585 66.526487v349.640145c0 10.882327-8.823156 22.401396-19.705483 22.401397s-19.705484-11.286342-19.705484-22.168669v-349.872873c0-15.034182-6.170065-28.725993-16.106589-38.662517-9.934662-9.934662-23.622749-16.104727-38.660655-16.104727H221.938036c-15.039767 0-28.729716 6.168204-38.664378 16.102866-9.934662 9.934662-16.102865 23.624611-16.102865 38.664378v579.50208c0 15.039767 6.168204 28.729716 16.102865 38.664378 9.934662 9.934662 23.624611 16.102865 38.664378 16.102865h435.963346z",
          "p-id": "5140",
          "fill": "#5878fa"
        }
      }), _vm._v(" "), _c('path', {
        attrs: {
          "d": "M662.965527 506.455505h-0.633018",
          "p-id": "5141",
          "fill": "#5878fa"
        }
      }), _vm._v(" "), _c('path', {
        attrs: {
          "d": "M351.250618 363.834647h391.635317v26.273978H351.250618zM351.250618 519.035811h391.635317v26.273978H351.250618zM351.250618 674.236975h160.121949v26.273978H351.250618z",
          "p-id": "5142",
          "fill": "#5878fa"
        }
      }), _vm._v(" "), _c('path', {
        attrs: {
          "d": "M260.952436 355.221876h43.49952v43.49952H260.952436zM260.952436 510.42304h43.49952v43.49952H260.952436zM260.952436 665.624204h43.49952v43.49952H260.952436z",
          "p-id": "5143",
          "fill": "#5878fa"
        }
      }), _vm._v(" "), _c('path', {
        attrs: {
          "d": "M638.30016 792.324655c-11.682909 0-21.153978-9.472931-21.153978-21.153979 0-11.682909 9.471069-21.153978 21.153978-21.153978h247.37792c11.682909 0 21.153978 9.471069 21.153978 21.153978 0 11.681047-9.471069 21.153978-21.153978 21.153979H638.30016z",
          "p-id": "5144",
          "fill": "#5878fa"
        }
      }), _vm._v(" "), _c('path', {
        attrs: {
          "d": "M795.785775 890.969367c-8.21248 8.260887-21.569164 8.296262-29.830051 0.083782-8.259025-8.214342-8.2944-21.571025-0.08192-29.830051l90.108276-90.158545-89.903476-89.951884c-8.21248-8.260887-8.177105-21.617571 0.083781-29.830051 8.259025-8.214342 21.615709-8.178967 29.830051 0.08192l104.641629 104.703069c6.428858 6.464233 7.80288 16.048873 4.138822 23.848029-1.016553 2.303069-2.463185 4.460916-4.343622 6.352524l-104.64349 104.701207z",
          "p-id": "5145",
          "fill": "#5878fa"
        }
      })]), _vm._v(" "), _c('span', {
        staticStyle: {
          "padding-top": "3px"
        }
      }, [_vm._v("出货单")])])])
    }), _vm._v(" "), _c('div', {
      staticClass: "full-split-line",
      staticStyle: {
        "margin-bottom": "10px"
      }
    }), _vm._v(" "), (!express.routes) ? _c('div', {
      staticClass: "block-express-invalid"
    }, [_vm._v("由于时间过长,无法为您提供该快递的物流信息,具体咨询\n      "), (express.company === 1) ? _c('span', [_vm._v("顺丰快递")]) : _c('span', [_vm._v("跨越快递")])]) : (express.routes && express.routes[0] && !express.showAll) ? _c('div', {
      staticClass: "block-express leftDiv"
    }, [_c('svg', {
      staticClass: "currentIcon",
      staticStyle: {
        "margin-top": "-10px"
      },
      attrs: {
        "width": "14px",
        "height": "14px",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "fill": "none",
        "version": "1.1",
        "viewBox": "0 0 17 17"
      }
    }, [_c('g', [_c('g', [_c('ellipse', {
      attrs: {
        "cx": "8.5",
        "cy": "8.5",
        "rx": "8.5",
        "ry": "8.5",
        "fill": "#5878FA"
      }
    })]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
      attrs: {
        "d": "M12.31888,5.92376C11.45951,4.71511,10.05733,3.99747287,8.56299,4.00149319L8.56374,4.0000144239C6.61387,3.99515438,4.877516,5.21888,4.246297,7.04283C3.432642,9.39397,4.700883,11.95205,7.079000000000001,12.75648C9.45712,13.5609,12.04457,12.30706,12.85823,9.95593C12.85858,9.954979999999999,12.85892,9.954039999999999,12.85925,9.95309C12.92073,9.77952,12.82826,9.58954,12.6527,9.52876C12.47584,9.465910000000001,12.28078,9.55555,12.21537,9.72973C11.92629,10.52698,11.37464,11.20506,10.648959999999999,11.65512C8.86125,12.76387,6.50288,12.2299,5.3814,10.46247C4.259928,8.695039999999999,4.80003,6.363440000000001,6.58775,5.25469C8.37547,4.145935,10.733830000000001,4.679908,11.85531,6.4473400000000005L11.03392,6.4473400000000005C10.84749,6.4563500000000005,10.70375,6.6130700000000004,10.71286,6.79738C10.72198,6.98169,10.8805,7.1238,11.06692,7.11479L12.6917,7.11479C12.86571,7.099130000000001,12.99918,6.95529,13,6.7825500000000005L13,5.19327C12.9835,5.01981,12.83613,4.887289,12.6599,4.887437C12.47141,4.887595,12.31872,5.0388,12.31888,5.22516L12.31888,5.92376ZM8.90278,5.97201C8.885010000000001,5.7999,8.73795,5.6692800000000005,8.56297,5.67017C8.37646,5.6697500000000005,8.22447,5.81803,8.22241,6.002409999999999L8.22241,8.48534C8.23302,8.58031,8.284379999999999,8.66621,8.36344,8.72117L9.956710000000001,9.8336L9.98446,9.8514C10.14215,9.9409,10.34307,9.89343,10.442789999999999,9.743120000000001C10.54128,9.5932,10.50179,9.39307,10.35353,9.29074L8.90278,8.27843L8.90278,5.97201Z",
        "fill-rule": "evenodd",
        "fill": "#FFFFFF"
      }
    })])])])]), _vm._v(" "), (!express.showAll) ? _c('div', {
      staticClass: "div div_2"
    }) : _vm._e(), _vm._v(" "), (!express.showAll) ? _c('div', {
      staticClass: "item-detail"
    }, [_c('span', {
      staticClass: "express-opcode-color"
    }, [_vm._v(_vm._s(express.routes[0].opcode))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "center"
      }
    }, [_c('span', {
      staticClass: "express-text-color",
      staticStyle: {
        "position": "relative"
      }
    }, [_vm._v(_vm._s(express.routes[0].remark))])]), _vm._v(" "), _c('span', {
      staticClass: "express-text-color"
    }, [_vm._v(_vm._s(express.routes[0].acceptTime))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((express.routes), function(route, i) {
      return (express.showAll) ? _c('div', {
        staticClass: "block-express leftDiv",
        staticStyle: {
          "display": "flex",
          "align-items": "start"
        }
      }, [(i !== 0) ? _c('div', {
        staticClass: "colorDiv_2 left1"
      }) : _vm._e(), _vm._v(" "), (i !== 0) ? _c('div', {
        staticClass: "div div_2",
        attrs: {
          "ali": ""
        }
      }) : _vm._e(), _vm._v(" "), (i === 0) ? _c('svg', {
        staticClass: "currentIcon",
        staticStyle: {
          "margin-top": "-10px"
        },
        attrs: {
          "width": "14px",
          "height": "14px",
          "xmlns": "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "fill": "none",
          "version": "1.1",
          "viewBox": "0 0 17 17"
        }
      }, [_c('g', [_c('g', [_c('ellipse', {
        attrs: {
          "cx": "8.5",
          "cy": "8.5",
          "rx": "8.5",
          "ry": "8.5",
          "fill": "#5878FA"
        }
      })]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
        attrs: {
          "d": "M12.31888,5.92376C11.45951,4.71511,10.05733,3.99747287,8.56299,4.00149319L8.56374,4.0000144239C6.61387,3.99515438,4.877516,5.21888,4.246297,7.04283C3.432642,9.39397,4.700883,11.95205,7.079000000000001,12.75648C9.45712,13.5609,12.04457,12.30706,12.85823,9.95593C12.85858,9.954979999999999,12.85892,9.954039999999999,12.85925,9.95309C12.92073,9.77952,12.82826,9.58954,12.6527,9.52876C12.47584,9.465910000000001,12.28078,9.55555,12.21537,9.72973C11.92629,10.52698,11.37464,11.20506,10.648959999999999,11.65512C8.86125,12.76387,6.50288,12.2299,5.3814,10.46247C4.259928,8.695039999999999,4.80003,6.363440000000001,6.58775,5.25469C8.37547,4.145935,10.733830000000001,4.679908,11.85531,6.4473400000000005L11.03392,6.4473400000000005C10.84749,6.4563500000000005,10.70375,6.6130700000000004,10.71286,6.79738C10.72198,6.98169,10.8805,7.1238,11.06692,7.11479L12.6917,7.11479C12.86571,7.099130000000001,12.99918,6.95529,13,6.7825500000000005L13,5.19327C12.9835,5.01981,12.83613,4.887289,12.6599,4.887437C12.47141,4.887595,12.31872,5.0388,12.31888,5.22516L12.31888,5.92376ZM8.90278,5.97201C8.885010000000001,5.7999,8.73795,5.6692800000000005,8.56297,5.67017C8.37646,5.6697500000000005,8.22447,5.81803,8.22241,6.002409999999999L8.22241,8.48534C8.23302,8.58031,8.284379999999999,8.66621,8.36344,8.72117L9.956710000000001,9.8336L9.98446,9.8514C10.14215,9.9409,10.34307,9.89343,10.442789999999999,9.743120000000001C10.54128,9.5932,10.50179,9.39307,10.35353,9.29074L8.90278,8.27843L8.90278,5.97201Z",
          "fill-rule": "evenodd",
          "fill": "#FFFFFF"
        }
      })])])])]) : _vm._e(), _vm._v(" "), (i === 0) ? _c('div', {
        staticClass: "div div_2"
      }) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "item-detail"
      }, [_c('span', {
        class: i === 0 ? 'express-opcode-color' : 'over-express-opcode-color'
      }, [_vm._v(_vm._s(route.opcode))]), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "flex",
          "align-items": "center"
        }
      }, [_c('span', {
        class: i === 0 ? 'express-text-color' : 'over-express-text-color',
        staticStyle: {
          "position": "relative"
        }
      }, [_vm._v(_vm._s(route.remark))])]), _vm._v(" "), _c('span', {
        class: i === 0 ? 'express-text-color' : 'over-express-text-color'
      }, [_vm._v(_vm._s(route.acceptTime))])])]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "full-split-line"
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!express.showAll && express.routes),
        expression: "!express.showAll && express.routes"
      }],
      staticClass: "group_2",
      staticStyle: {
        "text-align": "center"
      },
      on: {
        "click": function($event) {
          return _vm.changeOpen(express)
        }
      }
    }, [_c('span', {
      staticClass: "clickExpand",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("展开")]), _vm._v(" "), _c('svg', {
      staticClass: "icon",
      attrs: {
        "t": "1691030298315",
        "viewBox": "0 0 1024 1024",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "p-id": "1049",
        "width": "10",
        "height": "10",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    }, [_c('path', {
      attrs: {
        "d": "M832 325.504L512 637.504 192 325.504a28.8 28.8 0 0 0-41.984 0 28.8 28.8 0 0 0-8.96 20.992c0 8 2.624 14.72 7.936 20.032l340.992 331.968c6.016 6.016 13.376 8.96 22.016 8.96 8.704 0 16-2.944 22.016-8.96l341.056-331.008a31.232 31.232 0 0 0 7.936-21.504c0-8.32-2.944-15.36-8.96-20.992a29.76 29.76 0 0 0-41.984 0.512H832z",
        "p-id": "1050",
        "fill": "#bfbfbf"
      }
    })])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (express.showAll && express.routes),
        expression: "express.showAll && express.routes"
      }],
      staticClass: "group_2",
      on: {
        "click": function($event) {
          return _vm.changeOpen(express)
        }
      }
    }, [_c('span', {
      staticClass: "clickExpand",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("收起")]), _vm._v(" "), _c('svg', {
      staticClass: "icon",
      attrs: {
        "t": "1691030493766",
        "viewBox": "0 0 1024 1024",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "p-id": "1816",
        "width": "10",
        "height": "10",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    }, [_c('path', {
      attrs: {
        "d": "M488.96 311.04l-339.968 356.928a32.256 32.256 0 0 0-8.96 22.016c0 8 2.944 15.36 8.96 22.016v1.024c6.016 5.952 13.184 8.96 21.504 8.96 8.32 0 15.488-3.008 21.504-8.96l320-336 320 336c6.016 5.952 13.184 8.96 21.504 8.96 8.32 0 15.488-3.008 21.504-8.96v-1.024a32.256 32.256 0 0 0 8.96-22.016 32.256 32.256 0 0 0-8.96-22.016L534.976 311.04A31.168 31.168 0 0 0 512 302.08a31.168 31.168 0 0 0-23.04 8.96z",
        "p-id": "1817",
        "fill": "#bfbfbf"
      }
    })])])], 2)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92a1c568","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/emktcommon/orders/express/components/GcOrderExpressBase.vue
// module id = 1694
// module chunks = 8